import "../styles/globals.css";
// import ColorPicker from "../components/Dev";
import Layout from "../components/Layout";
import type { AppProps } from "next/app";
import Script from "next/script";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect, useRef } from "react";
import { Router } from "next/router";
import ProgressBar from "../components/ProgressBar";

function MyApp({ Component, pageProps }: AppProps<any>) {
  const oldUrlRef = useRef("");
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host:
          process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
        person_profiles: "identified_only",
        // Enable debug mode in development
        loaded: (posthog) => {
          if (process.env.NODE_ENV === "development") posthog.debug();
        },
      });

      const handleRouteChange = () => posthog?.capture("$pageview");

      const handleRouteChangeStart = () =>
        posthog?.capture("$pageleave", {
          $current_url: oldUrlRef.current,
        });

      Router.events.on("routeChangeComplete", handleRouteChange);
      Router.events.on("routeChangeStart", handleRouteChangeStart);

      return () => {
        Router.events.off("routeChangeComplete", handleRouteChange);
        Router.events.off("routeChangeStart", handleRouteChangeStart);
      };
    }
  }, []);
  return (
    <PostHogProvider client={posthog}>
      <Layout>
        <ProgressBar />
        <Component {...pageProps} />
      </Layout>
      {/* <ColorPicker /> */}
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-4B1BY9BBPD"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-4B1BY9BBPD');
        `}
      </Script>
    </PostHogProvider>
  );
}

export default MyApp;
